import BaseMask from "./_base.mask";

const CNPJ_MASK = "SS.SSS.SSS/SSSS-99";

const validateCnpj = (cnpj = "") => {
  cnpj = cnpj.toString().replace(/[^0-9a-zA-Z]+/gi, "");
  return cnpj.length === 14;
};

export class CnpjMask extends BaseMask {
  static getType() {
    return "cnpj";
  }

  getValue(value, settings) {
    return this.getVMasker().toPattern(value, CNPJ_MASK);
  }

  getRawValue(maskedValue, settings) {
    return maskedValue.replace(/[^0-9a-zA-Z]+/gi, "");
  }

  validate(value, settings) {
    return validateCnpj(value);
  }
}
